import template from './preview_modal.html';

angular.module('bb.util').component('previewModal', {
  transclude: true,
  bindings: {},
  controller: PreviewModalController,
  controllerAs: 'vm',
  template,
});

PreviewModalController.$inject = ['$rootScope', 'ModalService'];
function PreviewModalController($rootScope, ModalService) {
  const vm = this;

  vm.previewModal = ModalService.previewModal;

  vm.auth = $rootScope.auth;

  vm.closeModal = function () {
    ModalService.closePreviewModal();
  };
}
